import { HttpRequest } from '@angular/common/http';
import { INTERCEPTOR_EXCEPT_URL } from '@core/configs';

export const filterInterceptorRequest = (req: HttpRequest<any>): boolean => INTERCEPTOR_EXCEPT_URL.some(
  url => {
    if (typeof url === 'string') {
      return req.url.includes(url);
    } else {
      return url.test(req.url);
    }
  },
);
